import React from 'react';
import '../App.css';

//import { Navbar, Bq_header, Bq_blogs, Bq_ideas, Bq_libros} from '../container';
import { Header_2026, Footer_2026, Busqueda_2026_header, Busqueda_2026_blogs, Busqueda_2026_ideas, Busqueda_2026_libros } from '../container';

import { useAxios } from '../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BusquedaG = () => {
  const { words } = useParams();
  const [t, i18n] = useTranslation("global");
  const { data, isLoading, error } = useAxios(`/search?words=${words}&lang=${i18n.language}`);
  const { blogResult, booksResult, ideasResult } = !!data && data;

  const hasBlogs = blogResult?.total > 0;
  const hasIdeas = ideasResult?.total > 0;
  const hasBooks = booksResult?.total > 0;

  return (
    <>
      <Header_2026 />
      <div class="_nghost-ng-c2327341559">
        <section class="busqueda-page">
          <Busqueda_2026_header titulo={words} blogs={blogResult ? blogResult.total : 0} ideas={ideasResult ? ideasResult.total : 0} libros={booksResult ? booksResult.total : 0} />
          <div class="busqueda-page__content">

            {hasBlogs && (
              <Busqueda_2026_blogs contenido={blogResult} />
            )}

            {hasBlogs && (hasIdeas || hasBooks) && (
              <div
                aria-hidden="true"
                class="busqueda-page__divider"
              />
            )}

            {hasIdeas && (
              <Busqueda_2026_ideas contenidoideas={ideasResult} />
            )}

            {hasIdeas && hasBooks && (
              <div
                aria-hidden="true"
                class="busqueda-page__divider"
              />
            )}

            {hasBooks && (
              <Busqueda_2026_libros contenido={booksResult} />
            )}

          </div>
        </section>
      </div>
      <Footer_2026 />

    </>
  )
}

export default BusquedaG
